<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<section class="error-section py-40">
			<div class="container-fluid">
				<div class="error-wrapper text-center py-40 bg-white br-10">
					<div class="fs-1 mb-32">Заказ Успешно Создан</div>
					<router-link :to="{path: '/catalog'}" class="cus-btn">Продолжить покупки</router-link>
				</div>
			</div>
		</section>            

		<benefits :footer-class="['bg-white']" />
	</main>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Ошибка 404'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
	},
}
</script>